// extracted by mini-css-extract-plugin
export default {"container":"App_container__nR+-1"};